import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { DecimalPipe } from "@angular/common";
import { Observable } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { CountryService } from "./country.service";
import { TimeZoneUtils } from "../utils/timezone.utils";
import { NgbdSortableHeader, SortEvent } from "./sortable.directive";
import { SystemUtils } from "../utils/system.utils";

interface jobsData {
  id: number;
  BotId: number;
  BotName: string;
  BotPath: string;
  LastModified: string;
  ParentId: number;
  Bot_orgId: string;
  orgId: number;
  BotPermission: any;
  Directory: number;
}

@Component({
  selector: "app-jobs",
  templateUrl: "./jobs.component.html",
  styleUrls: ["./jobs.component.css"],
  providers: [CountryService, DecimalPipe],
})
export class JobsComponent implements OnInit {
  isShown: boolean = false;
  iscustomSelected: boolean = true;
  ismachineProfileSelected: boolean = false;
  edit: any = "../../assets/images/icons/edit.png";
  jobLists: any = [];
  systemList: any = [];
  envList: any = [];

  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;
  pageSize: any = 0;

  congEdit: any = 0;
  aliasEdit: any = 0;
  accessEdit: any = 0;

  jobID: any = "";
  botName: any = "";
  importedDate: any = "";
  modifiedDate: any = "";
  lastmodified: any = "";
  botPath: any = "";
  alias: any = "";
  environmentId: any = "";
  masterEnvId: any = "";
  environmentName: any = "";
  status: any = "";
  Removed_From_AA: any = false;
  isPaginationClicked: any = false;

  isRemovedFromAA: boolean = false;
  isLoading: boolean = false;

  isFailure: boolean = false;
  failureMessage: any = "";
  isSuccess: boolean = false;
  successMessage: any = "";

  countries$: any;
  filterArray = [];
  actualArray = [];
  filterArraySize: any = 0;
  searchArray: any = [];
  pageLength: any = "";
  totalConfigured: any = "";
  notConfigured: any = "";

  jobArray: any = [];
  jobListWithoutTree: any = [];

  totalJobsCount: number = 0;
  paginationLength: number = 0;
  deleteBotLength: number = 0;
  paginationContainer: any = [];
  activepage: any = 1;
  paginationNumber: any;
  BotorgIdParentENV: any = "";

  isBotnameSorted: boolean = false;
  isBotIdSorted: boolean = false;
  isAliasSorted: boolean = false;
  isBotPathSorted: boolean = false;
  isLastModified: boolean = false;
  isStatusSorted: boolean = false;
  isAliasEmpty: boolean = false;

  constructor(
    public service: CountryService,
    private _restService: RestService,
    private router: Router
  ) {}

  ngOnInit() {
    this._restService
      .getBotLists()
      .pipe(
        catchError((e) => {
          // (this.isLoading = false),
          //   (this.isFailure = true),
          //   (this.failureMessage = e.error.StatusInfo);
          // console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          (this.jobLists = d.botList),
          (d.botList.forEach(m => {
            m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
            m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
            m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
          })),
          (this.countries$ = d.botList),
          (this.actualArray = d.botList),
          (this.actualArray = d.botList),
          (this.searchArray = d.botList),
          (this.totalConfigured = d.botListLength),
          (this.notConfigured = d.notConfigured),
          (this.deleteBotLength = d.deleteBot),
          (this.totalJobsCount = parseFloat(d.botListLength) / 7),
          (this.paginationLength =
            this.totalJobsCount % 1 === 0
              ? Math.round(this.totalJobsCount)
              : Math.round(this.totalJobsCount) + 1),
          this.loopingPagination(d.botListLength),
          this.countries$.map((f: any, index: any) =>
            index + 1 <= 7 ? this.filterArray.push(f) : ""
          ),
          (this.filterArraySize = this.filterArray.length),
          console.log("Filtered Array", this.filterArray),
          console.log("job list", this.countries$),
          console.log("ddd --->", d)
        )
      );

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.envList = f.EnvList),
          console.log("Data from Machine list", f.EnvList)
        )
      );
  }

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 7 ? 7 : l;
    this.pageSize = l;
    this.prevValue = 0;
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 7 >= pageSize ? pageSize : c + 7;
    this.prevValue = c;

    //console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 7 + 1;
    this.maxValue = p;
    this.prevValue = p - 7;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  currentPage(c: any) {
    this.filterArray = [];
    this.isPaginationClicked = true;
    let cp = c + 1;
    this.paginationNumber = cp;
    let maxValue = cp * 7;
    let minValue = maxValue - 7 + 1;
    console.log(minValue + "---" + maxValue);

    this.searchArray.map((f: any, index: any) =>
      index + 1 >= minValue && index + 1 <= maxValue
        ? this.filterArray.push(f)
        : ""
    ),
      (this.activepage = cp),
      (this.filterArraySize = this.filterArray.length),
      console.log("Filtered Array 2", this.filterArray);
  }

  onChangeAlias(e: any) {
    this.aliasEdit = 1;
  }

  onStatusChange(e: any) {
    this.congEdit = 1;
  }

  sortingBotName() {
    let sortedList: any = [];
    this.filterArray = [];
    if (this.isBotnameSorted === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.BotName.localeCompare(b.BotName);
      });
      this.isBotnameSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.BotName.localeCompare(a.BotName);
      });
      this.isBotnameSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  sortingJobID() {
    let sortedList: any = [];
    this.filterArray = [];
    if (this.isBotIdSorted === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.BotId - b.BotId;
      });
      this.isBotIdSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.BotId - a.BotId;
      });
      this.isBotIdSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  sortingAlias() {
    let sortedList: any = [];
    this.filterArray = [];
    if (this.isAliasSorted === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.Alias.localeCompare(b.Alias);
      });
      this.isAliasSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.Alias.localeCompare(a.Alias);
      });
      this.isAliasSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  sortingBotPath() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isBotPathSorted === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.BotPath.localeCompare(b.BotPath);
      });
      this.isBotPathSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.BotName.localeCompare(a.BotName);
      });
      this.isBotPathSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  sortingStatus() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isStatusSorted === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.Status - b.Status;
      });
      this.isStatusSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.Status - a.Status;
      });
      this.isStatusSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  sortingLastModified() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isLastModified === false) {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return a.LastModified.localeCompare(b.LastModified);
      });
      this.isLastModified = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      sortedList = this.countries$.sort(function (a: any, b: any) {
        return b.LastModified.localeCompare(a.LastModified);
      });
      this.isLastModified = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 7),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    }
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        (this.totalJobsCount = this.countries$.length),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.paginationLength),
        this.countries$.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        ),
        (this.filterArraySize = this.filterArray.length),
        (this.activepage = 1);
    } else {
      let v = e.target.value.toLowerCase();
      this.searchArray = [];
      let searchLength: any;
      let lists = this.countries$;
      this.filterArray = [];

      this.countries$.map((f: any) =>
        f.BotName.toLowerCase().includes(v) ||
        f.BotPath.toLowerCase().includes(v) ||
        f.LastModified.toLowerCase().includes(v)
          ? (this.searchArray.push(f),
            console.log("SearchArray", this.searchArray))
          : ""
      ),
        (this.totalJobsCount = this.searchArray.length),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount)),
        this.loopingPagination(this.paginationLength),
        this.searchArray.map((f: any, index: any) =>
          index + 1 <= 7 ? this.filterArray.push(f) : ""
        );
      this.filterArraySize = this.filterArray.length;
    }
  }

  customEvent(e: any) {
    e.target.checked === true
      ? ((this.iscustomSelected = true),
        (this.ismachineProfileSelected = false))
      : (this.iscustomSelected = false);
  }

  machineProfileEvent(e: any) {
    e.target.checked === true
      ? ((this.ismachineProfileSelected = true),
        (this.iscustomSelected = false))
      : (this.ismachineProfileSelected = false);
  }

  onEditJob(
    id: any,
    BotorgIdParentENV: any,
    BotId: any,
    BotName: any,
    ImportedDate: any,
    ModifiedDate: any,
    LastModified: any,
    BotPath: any,
    Alias: any,
    EnvironmentName: any,
    Status: any,
    RemovedFromAA: any,
    menvid: any,
    envType: any
  ) {
    this.isShown = true;
    (this.isLoading = true), (this.jobID = BotId);
    this.botName = BotName;
    this.importedDate = ImportedDate;
    this.modifiedDate = ModifiedDate;
    this.lastmodified = LastModified;
    this.botPath = BotPath;
    this.alias = Alias;
    this.environmentName = EnvironmentName;
    this.status = Status;
    this.isRemovedFromAA = RemovedFromAA === 1 ? true : false;
    this.BotorgIdParentENV = BotorgIdParentENV;
    this.masterEnvId = menvid;
    // alert(this.Removed_From_AA)

    this._restService
      .getBotDetail(BotorgIdParentENV, BotId, this.masterEnvId, envType)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          f.systemAccess.map(
            (a: any) => (
              (a.isSystemEdited = false),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      (b.isSystemEdited = false),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              (c.isSystemEdited = false),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      (d.isSystemEdited = false),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) =>
                                              (f.isSystemEdited = false),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    (g.isSystemEdited = false),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isSystemEdited = false),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    (j.isSystemEdited = false),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            k: any
                                                                          ) => (
                                                                            (k.isSystemEdited = false),
                                                                            k.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? k.children.map(
                                                                                  (
                                                                                    l: any
                                                                                  ) =>
                                                                                    (l.isSystemEdited = false)
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          ),
          (this.systemList = f.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          (this.environmentId = f.botResults.Environment),
          //(this.isRemovedFromAA =
          //f.botResults.RemovedFromAA === 1 ? true : false),
          console.log("job Details ---->>>", f.systemAccess),
          console.log("this.Removed_From_AA", this.Removed_From_AA),
          console.log("this.Removed_From_AA", f.botResults.Removed_From_AA)
        )
      );
  }

  levelTwoEvent(id: any) {
    this.accessEdit = 1;
    let list = this.systemList;
    list.map((f: any) => (f.categoryId === id ? (f.Visible = !f.Visible) : ""));
    this.systemList = list;
  }

  collapseEvent(c1: any) {
    let list = this.systemList;
    list.map((a: any) =>
      a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? (b.Visible = !b.Visible)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? (c.Visible = !c.Visible)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? (d.Visible = !d.Visible)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? (f.Visible = !f.Visible)
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? (g.Visible = !g.Visible)
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? (h.Visible = !h.Visible)
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? (j.Visible = !j.Visible)
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? (k.Visible =
                                                            k.Visible)
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? (l.Visible =
                                                                    l.Visible)
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  isChecked2(cId: any) {    
    const accessMap = {};
    this.buildAccessMap(this.systemList, accessMap);

    const newVal = !accessMap[cId].isChecked;
    this.updateAccess(accessMap[cId], newVal);

    if (newVal) {
      while (accessMap[cId].parentId != 0 ) {
        cId = accessMap[cId].parentId;

        if (accessMap[cId].isChecked) {
          break;
        }
        accessMap[cId].isChecked = newVal;
        accessMap[cId].isSystemEdited = true;
      }
    } 
  }

  updateAccess(access: any, val: boolean) {
    access.isChecked = val;
    access.isSystemEdited = true;

    if (access.children){
      access.children.forEach( child => this.updateAccess(child, val));
    }
  }

  buildAccessMap(accessList: any, map: any) {
    if (!accessList)
      return map;

    accessList.forEach(access => {
      map[access.categoryId] = access;

      this.buildAccessMap(access.children, map);
    })
  }

  isChecked(c1: any) {
    let list = this.systemList;
    this.accessEdit = 1;
    list.map((f: any) =>
      f.categoryId === c1
        ? ((f.isChecked = !f.isChecked), (f.isSystemEdited = true))
        : ""
    ),
      list.map((a: any) =>
        a.hasOwnProperty("children")
          ? a.children.map((b: any) =>
              b.categoryId === c1
                ? ((b.isChecked = !b.isChecked), (b.isSystemEdited = true))
                : b.hasOwnProperty("children")
                ? b.children.map((c: any) =>
                    c.categoryId === c1
                      ? ((c.isChecked = !c.isChecked),
                        (c.isSystemEdited = true))
                      : c.hasOwnProperty("children")
                      ? c.children.map((d: any) =>
                          d.categoryId === c1
                            ? ((d.isChecked = !d.isChecked),
                              (d.isSystemEdited = true))
                            : d.hasOwnProperty("children")
                            ? d.children.map((f: any) =>
                                f.categoryId === c1
                                  ? ((f.isChecked = !f.isChecked),
                                    (f.isSystemEdited = true))
                                  : f.hasOwnProperty("children")
                                  ? f.children.map((g: any) =>
                                      g.categoryId === c1
                                        ? ((g.isChecked = !g.isChecked),
                                          (g.isSystemEdited = true))
                                        : g.hasOwnProperty("children")
                                        ? g.children.map((h: any) =>
                                            h.categoryId === c1
                                              ? ((h.isChecked = !h.isChecked),
                                                (h.isSystemEdited = true))
                                              : h.hasOwnProperty("children")
                                              ? h.children.map((j: any) =>
                                                  j.categoryId === c1
                                                    ? ((j.isChecked = !j.isChecked),
                                                      (j.isSystemEdited = true))
                                                    : j.hasOwnProperty(
                                                        "children"
                                                      )
                                                    ? j.children.map((k: any) =>
                                                        k.categoryId === c1
                                                          ? ((k.isChecked = !k.isChecked),
                                                            (k.isSystemEdited = true))
                                                          : k.hasOwnProperty(
                                                              "children"
                                                            )
                                                          ? k.children.map(
                                                              (l: any) =>
                                                                l.categoryId ===
                                                                c1
                                                                  ? ((l.isChecked = !l.isChecked),
                                                                    (l.isSystemEdited = true))
                                                                  : ""
                                                            )
                                                          : ""
                                                      )
                                                    : ""
                                                )
                                              : ""
                                          )
                                        : ""
                                    )
                                  : ""
                              )
                            : ""
                        )
                      : ""
                  )
                : ""
            )
          : ""
      );

    list.map((a: any) =>
      a.categoryId === c1
        ? a.isChecked === false
          ? this.parentChildRelation(c1, a.children, false)
          : this.parentChildRelation(c1, a.children, true)
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? b.isChecked === false
                ? this.parentChildRelation(c1, b.children, false)
                : this.parentChildRelation(c1, b.children, true)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? c.isChecked === false
                      ? this.parentChildRelation(c1, c.children, false)
                      : this.parentChildRelation(c1, c.children, true)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? d.isChecked === false
                            ? this.parentChildRelation(c1, d.children, false)
                            : this.parentChildRelation(c1, d.children, true)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? f.isChecked === false
                                  ? this.parentChildRelation(
                                      c1,
                                      f.children,
                                      false
                                    )
                                  : this.parentChildRelation(
                                      c1,
                                      f.children,
                                      true
                                    )
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? g.isChecked === false
                                        ? this.parentChildRelation(
                                            c1,
                                            g.children,
                                            false
                                          )
                                        : this.parentChildRelation(
                                            c1,
                                            g.children,
                                            true
                                          )
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? h.isChecked === false
                                              ? this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  false
                                                )
                                              : this.parentChildRelation(
                                                  c1,
                                                  h.children,
                                                  true
                                                )
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? j.isChecked === false
                                                    ? this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        false
                                                      )
                                                    : this.parentChildRelation(
                                                        c1,
                                                        j.children,
                                                        true
                                                      )
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? k.isChecked === false
                                                          ? this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              false
                                                            )
                                                          : this.parentChildRelation(
                                                              c1,
                                                              k.children,
                                                              true
                                                            )
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? l.isChecked ===
                                                                  false
                                                                  ? this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      false
                                                                    )
                                                                  : this.parentChildRelation(
                                                                      c1,
                                                                      l.children,
                                                                      true
                                                                    )
                                                                : l.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                ? l.children.map(
                                                                    (m: any) =>
                                                                      m.categoryId ===
                                                                      c1
                                                                        ? m.isChecked ===
                                                                          false
                                                                          ? this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              false
                                                                            )
                                                                          : this.parentChildRelation(
                                                                              c1,
                                                                              m.children,
                                                                              true
                                                                            )
                                                                        : ""
                                                                  )
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  parentChildRelation(c1: any, childArray: any, status: any) {
    console.log(c1);
    console.log(childArray);

    console.log("Before asasas ---->>>>", this.systemList);

    if (!childArray){
      return;
    }

    let disabledArray: any;

    status === false
      ? childArray.map(
          (a: any) => (
            ((a.isChecked = false),
            (a.isEnabled = false),
            (a.isSystemEdited = true)),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    ((b.isChecked = false),
                    (b.isEnabled = false),
                    (b.isSystemEdited = true)),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            ((c.isChecked = false),
                            (c.isEnabled = false),
                            (c.isSystemEdited = true)),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    ((d.isChecked = false),
                                    (d.isEnabled = false),
                                    (d.isSystemEdited = true)),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            ((f.isChecked = false),
                                            (f.isEnabled = false),
                                            (f.isSystemEdited = true)),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    ((g.isChecked = false),
                                                    (g.isEnabled = false),
                                                    (g.isSystemEdited = true)),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            (h.isChecked = false),
                                                            (h.isEnabled = false),
                                                            (h.isSystemEdited = true),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    ((j.isChecked = false),
                                                                    (j.isEnabled = false),
                                                                    (j.isSystemEdited = true)),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            k: any
                                                                          ) => (
                                                                            ((k.isChecked = false),
                                                                            (k.isEnabled = false),
                                                                            (k.isSystemEdited = true)),
                                                                            k.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? k.children.map(
                                                                                  (
                                                                                    l: any
                                                                                  ) => (
                                                                                    ((l.isChecked = false),
                                                                                    (l.isEnabled = false),
                                                                                    (l.isSystemEdited = true)),
                                                                                    l.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? l.children.map(
                                                                                          (
                                                                                            m: any
                                                                                          ) => (
                                                                                            (m.isChecked = false),
                                                                                            (m.isEnabled = false),
                                                                                            (m.isSystemEdited = true)
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : status === true
      ? childArray.map(
          (a: any) => (
            ((a.isChecked = true), (a.isEnabled = true)),
            a.hasOwnProperty("children")
              ? a.children.map(
                  (b: any) => (
                    ((b.isChecked = true), (b.isEnabled = true)),
                    b.hasOwnProperty("children")
                      ? b.children.map(
                          (c: any) => (
                            ((c.isChecked = true), (c.isEnabled = true)),
                            c.hasOwnProperty("children")
                              ? c.children.map(
                                  (d: any) => (
                                    ((d.isChecked = true),
                                    (d.isEnabled = true)),
                                    d.hasOwnProperty("children")
                                      ? d.children.map(
                                          (f: any) => (
                                            ((f.isChecked = true),
                                            (f.isEnabled = true)),
                                            f.hasOwnProperty("children")
                                              ? f.children.map(
                                                  (g: any) => (
                                                    ((g.isChecked = true),
                                                    (g.isEnabled = true)),
                                                    g.hasOwnProperty("children")
                                                      ? g.children.map(
                                                          (h: any) => (
                                                            ((h.isChecked = true),
                                                            (h.isEnabled = true)),
                                                            h.hasOwnProperty(
                                                              "children"
                                                            )
                                                              ? h.children.map(
                                                                  (j: any) => (
                                                                    ((j.isChecked = true),
                                                                    (j.isEnabled = true)),
                                                                    j.hasOwnProperty(
                                                                      "children"
                                                                    )
                                                                      ? j.children.map(
                                                                          (
                                                                            h: any
                                                                          ) => (
                                                                            ((h.isChecked = true),
                                                                            (h.isEnabled = true)),
                                                                            h.hasOwnProperty(
                                                                              "children"
                                                                            )
                                                                              ? h.children.map(
                                                                                  (
                                                                                    j: any
                                                                                  ) => (
                                                                                    ((j.isChecked = true),
                                                                                    (j.isEnabled = true)),
                                                                                    j.hasOwnProperty(
                                                                                      "children"
                                                                                    )
                                                                                      ? j.children.map(
                                                                                          (
                                                                                            k: any
                                                                                          ) => (
                                                                                            ((k.isChecked = true),
                                                                                            (k.isEnabled = true)),
                                                                                            k.hasOwnProperty(
                                                                                              "children"
                                                                                            )
                                                                                              ? k.children.map(
                                                                                                  (
                                                                                                    l: any
                                                                                                  ) => (
                                                                                                    ((l.isChecked = true),
                                                                                                    (l.isEnabled = true)),
                                                                                                    l.hasOwnProperty(
                                                                                                      "children"
                                                                                                    )
                                                                                                      ? l.children.map(
                                                                                                          (
                                                                                                            m: any
                                                                                                          ) => (
                                                                                                            ((m.isChecked = true),
                                                                                                            (m.isEnabled = true)),
                                                                                                            m.hasOwnProperty(
                                                                                                              "children"
                                                                                                            )
                                                                                                              ? ""
                                                                                                              : ""
                                                                                                          )
                                                                                                        )
                                                                                                      : ""
                                                                                                  )
                                                                                                )
                                                                                              : ""
                                                                                          )
                                                                                        )
                                                                                      : ""
                                                                                  )
                                                                                )
                                                                              : ""
                                                                          )
                                                                        )
                                                                      : ""
                                                                  )
                                                                )
                                                              : ""
                                                          )
                                                        )
                                                      : ""
                                                  )
                                                )
                                              : ""
                                          )
                                        )
                                      : ""
                                  )
                                )
                              : ""
                          )
                        )
                      : ""
                  )
                )
              : ""
          )
        )
      : "";

    disabledArray = this.systemList;

    disabledArray.map((a: any) =>
      a.categoryId === c1
        ? ((a.children = []), (a.children = childArray))
        : a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? ((b.children = []), (b.children = childArray))
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? ((c.children = []), (c.children = childArray))
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? ((d.children = []), (d.children = childArray))
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? ((f.children = []), (f.children = childArray))
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? ((g.children = []),
                                        (g.children = childArray))
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? ((h.children = []),
                                              (h.children = childArray))
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? ((j.children = []),
                                                    (j.children = childArray))
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? ((k.children = []),
                                                          (k.children = childArray))
                                                        : k.hasOwnProperty(
                                                            "children"
                                                          )
                                                        ? k.children.map(
                                                            (l: any) =>
                                                              l.categoryId ===
                                                              c1
                                                                ? ((l.children = []),
                                                                  (l.children = childArray))
                                                                : ""
                                                          )
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );

    this.systemList = disabledArray;
    console.log("After asasas ---->>>>", this.systemList);
  }

  saveJobDetails() {
    console.log("Full List", this.systemList);
    (this.jobArray = []),
      (this.isLoading = true),
      this.systemList.map(
        (a: any) => (
          this.jobArray.push(a),
          a.hasOwnProperty("children")
            ? a.children.map(
                (b: any) => (
                  this.jobArray.push(b),
                  b.hasOwnProperty("children")
                    ? b.children.map(
                        (c: any) => (
                          this.jobArray.push(c),
                          c.hasOwnProperty("children")
                            ? c.children.map(
                                (d: any) => (
                                  this.jobArray.push(d),
                                  d.hasOwnProperty("children")
                                    ? d.children.map(
                                        (f: any) => (
                                          this.jobArray.push(f),
                                          f.hasOwnProperty("children")
                                            ? f.children.map(
                                                (g: any) => (
                                                  this.jobArray.push(g),
                                                  g.hasOwnProperty("children")
                                                    ? g.children.map(
                                                        (h: any) => (
                                                          this.jobArray.push(h),
                                                          h.hasOwnProperty(
                                                            "children"
                                                          )
                                                            ? h.children.map(
                                                                (j: any) => (
                                                                  this.jobArray.push(
                                                                    j
                                                                  ),
                                                                  j.hasOwnProperty(
                                                                    "children"
                                                                  )
                                                                    ? j.children.map(
                                                                        (
                                                                          k: any
                                                                        ) => (
                                                                          this.jobArray.push(
                                                                            k
                                                                          ),
                                                                          k.hasOwnProperty(
                                                                            "children"
                                                                          )
                                                                            ? this.jobArray.push(
                                                                                k
                                                                              )
                                                                            : ""
                                                                        )
                                                                      )
                                                                    : ""
                                                                )
                                                              )
                                                            : ""
                                                        )
                                                      )
                                                    : ""
                                                )
                                              )
                                            : ""
                                        )
                                      )
                                    : ""
                                )
                              )
                            : ""
                        )
                      )
                    : ""
                )
              )
            : ""
        )
      ),
      console.log("Job Array", this.jobArray),
      (this.jobListWithoutTree = []),
      (this.jobListWithoutTree = this.jobArray.map(
        ({ children, ...rest }) => rest
      )),
      console.log("JobListWithoutTree", this.jobListWithoutTree),
      this.alias === ""
        ? ((this.isAliasEmpty = true), (this.isLoading = false))
        : this._restService
            .updateBotDetail(
              this.jobID,
              this.alias,
              this.status,
              this.jobListWithoutTree,
              this.BotorgIdParentENV,
              this.environmentId,
              this.congEdit,
              this.aliasEdit,
              this.accessEdit,
              this.masterEnvId
            )
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe(
              (d: any) => (
                (this.isLoading = false),
                (this.isAliasEmpty = false),
                (this.congEdit = 0),
                (this.aliasEdit = 0),
                (this.accessEdit = 0),
                this._restService
                  .getBotLists()
                  .pipe(
                    catchError((e) => {
                      (this.isLoading = false),
                        (this.isFailure = true),
                        (this.failureMessage = e.error.StatusInfo);
                      console.log("Onload Error --->", e.error);
                      return e;
                    })
                  )
                  .subscribe(
                    (d: any) => (
                      (d.botList.forEach(m => {
                        m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                        m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                        m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
                      })),
                      (this.jobLists = d.botList),
                      (this.countries$ = d.botList),
                      (this.actualArray = d.botList),
                      (this.searchArray = d.botList),
                      (this.filterArray = d.botList),
                      (this.totalConfigured = d.botListLength),
                      (this.notConfigured = d.notConfigured),
                      (this.filterArraySize = this.filterArray.length),
                      (this.totalJobsCount = parseFloat(d.botListLength) / 7),
                      (this.paginationLength =
                        this.totalJobsCount % 1 === 0
                          ? Math.round(this.totalJobsCount)
                          : Math.round(this.totalJobsCount) + 1),
                      this.loopingPagination(d.botListLength),
                      this.countries$.map((f: any, index: any) =>
                        index + 1 <= 7 ? this.filterArray.push(f) : ""
                      ),
                      (this.filterArraySize = this.filterArray.length),
                      console.log("Job List", d.botList),
                      console.log("paginationNumber", this.paginationNumber)
                    )
                  ),
                (this.isSuccess = true),
                (this.successMessage = d.StatusInfo),
                console.log("Save the job details", d)
              )
            );
  }

  acknowledgeandRemove() {
    this.isLoading = true;
    this._restService
      .deleteBot(this.jobID, this.environmentId)
      .pipe(
        catchError((e) => {
          (this.isShown = false),
            (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Data from Job list", f.botList),
          this._restService
            .getBotLists()
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe(
              (d: any) => (
                (this.isShown = false),
                (this.isPaginationClicked = false),
                (this.filterArray = []),
                (d.botList.forEach(m => {
                  m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                  m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                  m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
                })),
                (this.jobLists = d.botList),
                (this.countries$ = d.botList),
                (this.actualArray = d.botList),
                (this.searchArray = d.botList),
                (this.totalConfigured = d.botListLength),
                (this.notConfigured = d.notConfigured),
                (this.deleteBotLength = d.deleteBot),
                (this.totalJobsCount = parseFloat(d.botListLength) / 7),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(d.botListLength),
                this.countries$.map((f: any, index: any) =>
                  index + 1 <= 7 ? this.filterArray.push(f) : ""
                ),
                (this.activepage = 1),
                (this.filterArraySize = this.filterArray.length),
                console.log("Filtered Array", this.filterArray),
                console.log("job list", this.countries$),
                console.log("ddd --->", d)
              )
            ),
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  refresh() {
    (this.isLoading = true),
      this._restService
        .refreshBotList(this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Refresh Job", f),
            this._restService
              .getBotLists()
              .pipe(
                catchError((e) => {
                  console.log("err --->", e);
                  // alert("Something went wrong!");
                  return e;
                })
              )
              .subscribe(
                (d: any) => (
                  (this.filterArray = []),
                  (d.botList.forEach(m => {
                    m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                    m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                    m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
                  })),
                  (this.jobLists = d.botList),
                  (this.countries$ = d.botList),
                  (this.actualArray = d.botList),
                  (this.searchArray = d.botList),
                  (this.totalConfigured = d.botListLength),
                  (this.notConfigured = d.notConfigured),
                  (this.deleteBotLength = d.deleteBot),
                  (this.totalJobsCount = parseFloat(d.botListLength) / 7),
                  (this.paginationLength =
                    this.totalJobsCount % 1 === 0
                      ? Math.round(this.totalJobsCount)
                      : Math.round(this.totalJobsCount) + 1),
                  this.loopingPagination(d.botListLength),
                  this.countries$.map((f: any, index: any) =>
                    index + 1 <= 7 ? this.filterArray.push(f) : ""
                  ),
                  (this.activepage = 1),
                  (this.filterArraySize = this.filterArray.length),
                  console.log("Filtered Array", this.filterArray),
                  console.log("job list", this.countries$),
                  console.log("ddd --->", d),
                  (this.isLoading = false)
                )
              )
          )
        );
  }

  selectEnvironment(e: any) {
    this.isLoading = true;
    console.log("E", e.target.value);
    console.log("Filter", this.filterArray);
    let environmentID: any = e.target.value;

    //alert(environmentID);

    //masterEnvId

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(environmentID)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this.environmentId = environmentID;

    environmentID === "All"
      ? this._restService
          .getBotLists()
          .pipe(
            catchError((e) => {
              // (this.isLoading = false),
              //   (this.isFailure = true),
              //   (this.failureMessage = e.error.StatusInfo);
              // console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.jobLists = d.botList),
              (d.botList.forEach(m => {
                m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
              })),
              (this.countries$ = d.botList),
              (this.actualArray = d.botList),
              (this.searchArray = d.botList),
              (this.totalConfigured = d.botListLength),
              (this.notConfigured = d.notConfigured),
              (this.deleteBotLength = d.deleteBot),
              (this.totalJobsCount = parseFloat(d.botListLength) / 7),
              (this.paginationLength =
                this.totalJobsCount % 1 === 0
                  ? Math.round(this.totalJobsCount)
                  : Math.round(this.totalJobsCount) + 1),
              this.loopingPagination(d.botListLength),
              this.countries$.map((f: any, index: any) =>
                index + 1 <= 7 ? this.filterArray.push(f) : ""
              ),
              (this.filterArraySize = this.filterArray.length),
              (this.activepage = 1),
              (this.isLoading = false)
            )
          )
      : this._restService
          .filterBotLists(environmentID)
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.jobLists = d.botList),
              (this.countries$ = d.botList),
              (this.actualArray = d.botList),
              (this.searchArray = d.botList),
              (this.totalConfigured = d.botListLength),
              (this.notConfigured = d.notConfigured),
              (this.deleteBotLength = d.deleteBot),
              (this.totalJobsCount = parseFloat(d.botListLength) / 7),
              (this.paginationLength =
                this.totalJobsCount % 1 === 0
                  ? Math.round(this.totalJobsCount)
                  : Math.round(this.totalJobsCount) + 1),
              this.loopingPagination(d.botListLength),
              this.countries$.map((f: any, index: any) =>
                index + 1 <= 7 ? this.filterArray.push(f) : ""
              ),
              (this.filterArraySize = this.filterArray.length),
              (this.activepage = 1),
              (this.isLoading = false)
            )
          );
  }

  close() {
    var maxValue: any;
    var minValue: any;
    this.isShown = false;
    (this.isLoading = true), (this.jobLists = []);

    this.aliasEdit = 0;
    this.congEdit = 0;
    this.accessEdit = 0;

    this.environmentId === "All"
      ? this._restService
          .getBotLists()
          .pipe(
            catchError((e) => {
              // (this.isLoading = false),
              //   (this.isFailure = true),
              //   (this.failureMessage = e.error.StatusInfo);
              // console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.jobLists = d.botList),
              (d.botList.forEach(m => {
                m.ModifiedDate = TimeZoneUtils.timezoneConvert(m.ModifiedDate);
                m.ImportedDate = TimeZoneUtils.timezoneConvert(m.ImportedDate);
                m.LastModified = TimeZoneUtils.timezoneConvert(m.LastModified);
              })),
              (this.countries$ = d.botList),
              (this.actualArray = d.botList),
              (this.searchArray = d.botList),
              (this.totalConfigured = d.botListLength),
              (this.notConfigured = d.notConfigured),
              (this.deleteBotLength = d.deleteBot),
              (this.totalJobsCount = parseFloat(d.botListLength) / 7),
              (this.paginationLength =
                this.totalJobsCount % 1 === 0
                  ? Math.round(this.totalJobsCount)
                  : Math.round(this.totalJobsCount) + 1),
              this.loopingPagination(d.botListLength),
              this.countries$.map((f: any, index: any) =>
                index + 1 <= 7 ? this.filterArray.push(f) : ""
              ),
              (this.filterArraySize = this.filterArray.length),
              (this.activepage = 1),
              (this.isLoading = false)
            )
          )
      : this._restService
          .filterBotLists(this.environmentId)
          .pipe(
            catchError((e) => {
              (this.isLoading = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.StatusInfo);
              console.log("Onload Error --->", e.error);
              return e;
            })
          )
          .subscribe(
            (d: any) => (
              (this.filterArray = []),
              (this.jobLists = d.botList),
              (this.countries$ = d.botList),
              (this.actualArray = d.botList),
              (this.searchArray = d.botList),
              (this.totalConfigured = d.botListLength),
              (this.notConfigured = d.notConfigured),
              (this.deleteBotLength = d.deleteBot),
              (this.totalJobsCount = parseFloat(d.botListLength) / 7),
              (this.paginationLength =
                this.totalJobsCount % 1 === 0
                  ? Math.round(this.totalJobsCount)
                  : Math.round(this.totalJobsCount) + 1),
              this.loopingPagination(d.botListLength),
              this.countries$.map((f: any, index: any) =>
                index + 1 <= 7 ? this.filterArray.push(f) : ""
              ),
              (this.filterArraySize = this.filterArray.length),
              (this.activepage = 1),
              (this.isLoading = false)
            )
          );
  }

  copyMachineID(id: any) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = id;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  closeInfo() {
    this.deleteBotLength = 0;
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
